import { Page, PageHeader } from "@/components/common";
import { RoomsManager } from "@/components/RoomsManager";

export default function RoomsPage() {
  return (
    <Page>
      <PageHeader title="Labs & storage" subtitle="The labs and storage areas in your department, and which technician looks after each lab" />
      <RoomsManager />
    </Page>
  );
}
